var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.8657,
    cy: 41.7069,
    rx: 39.5862,
    ry: 40.2931,
    fill: "#F6D169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 41C82 63.6437 63.6437 82 41 82C18.3563 82 0 63.6437 0 41C0 18.3563 18.3563 0 41 0C63.6437 0 82 18.3563 82 41ZM11.6965 41C11.6965 57.1839 24.8161 70.3035 41 70.3035C57.1839 70.3035 70.3035 57.1839 70.3035 41C70.3035 24.8161 57.1839 11.6965 41 11.6965C24.8161 11.6965 11.6965 24.8161 11.6965 41Z",
    fill: "#FFE9AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4338 38.1404C27.6838 36.7255 30.9338 34.7446 33.9338 38.1404",
    stroke: "#FFE9AA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9207 52.136C45.0457 54.2584 40.1707 57.2297 35.6708 52.136",
    stroke: "#FFE9AA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9321 38.1404C50.1821 36.7255 53.4321 34.7446 56.4321 38.1404",
    stroke: "#FFE9AA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3416 37.5456C27.5915 36.1307 30.8415 34.1499 33.8415 37.5456",
    stroke: "#493500",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9207 51.5872C45.0457 53.7095 40.1707 56.6808 35.6708 51.5872",
    stroke: "#493500",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8418 37.5456C50.0918 36.1307 53.3418 34.1499 56.3417 37.5456",
    stroke: "#493500",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/Coin.15c0d53d149b9e9880f8cf5fddb008b3.svg";
export { ForwardRef as ReactComponent };